
import { mapState } from "vuex";
import { REPORT_PAGE_VISITED } from "@/constants/MixpanelEvents.js";
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

export default {
  components: {
    reportHeaderRow: () => import("@/components/report/report-header-row.vue"),
    ReportView: () => import("@/components/report/report-view.vue")
  },
  mounted() {
    this.mixPanelTrackEvent(REPORT_PAGE_VISITED);
  },
  computed: {
    ...mapState("restaurant", ["locationDetails"])
  }
};
